import type { BrandConfig } from "brand/BrandConfig";
import Logo from "./assets/logo.png";

/**
 * truelovelica.com sells under the Lovelica name, but its buyers are their own
 * bible-core project, `truelovelica` (Konnektive campaign 33): their
 * subscription, T&C and emails live there, apart from the adult Lovelica's.
 * The core API scopes the subscription it returns by this project.
 */
export const truelovelicaBrand: BrandConfig = {
  projectName: "truelovelica",
  name: "Lovelica",
  email: "hello@truelovelica.com",
  url: "https://app.truelovelica.com",
  logo: Logo,
  docLinks: {
    termsUrl: "https://truelovelica.com/terms-and-conditions/",
    privacyUrl: "https://truelovelica.com/privacy-policy/",
  },
  // No age gate on this app (RouteGuard runs with requiresConsent={false}).
  ageConsentVersion: "1.0",
  cancellationReasons: [
    {
      id: "not-enough-companions",
      text: "Not enough companions to choose from",
    },
    { id: "chatting-not-engaging", text: "Conversations are not engaging" },
    { id: "found-better-alternative", text: "I found a better alternative" },
    { id: "too-expensive", text: "It's too expensive" },
    { id: "dont-use-enough", text: "I don't use it enough" },
    { id: "other", text: "Other" },
  ],
};

/** Public pages on the marketing site. */
export const SITE_URL = "https://truelovelica.com";
export const PRICING_URL = `${SITE_URL}/pricing/`;
export const CONTACT_URL = `${SITE_URL}/contact-us/`;
